// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  data: [],
  roles: []
}

export const workTeamSlice = createSlice({
  name: 'workTeam',
  initialState,
  reducers: {
    setUsers: (state, action) => {
      state.data = action.payload
    },
    setRoles: (state, action) => {
      state.roles = action.payload
    }
  }
})

export const { setUsers, setRoles } = workTeamSlice.actions

export const workTeam = workTeamSlice.reducer
